



































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import { adminContentItemShowTabularColumns } from '@/modules/content-item/models/columns/content-item-show-tabular.columns'
import { ContentItemResourceType } from '@/modules/content-item/models/content-item-resource.model'
import ContentItemStatusView from '@/modules/content-item/components/shared/ContentItemStatusView.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import { AdminContentCampaignRoute } from '@/modules/content-campaign/routes/admin-content-campaign.route'
import AdminContentItemUpdateAttributes from '@/modules/content-item/components/admin/AdminContentItemUpdateAttributes.vue'
import ContentItemDeliverAt from '@/modules/content-item/components/shared/ContentItemDeliverAt.vue'
import AdminContentItemSendToQueue from '@/modules/content-item/components/admin/AdminContentItemSendToQueue.vue'
import AdminContentItemSendToReview from '@/modules/content-item/components/admin/AdminContentItemSendToReview.vue'
import AdminContentItemSendToCompleted from '@/modules/content-item/components/admin/AdminContentItemSendToCompleted.vue'

@Component({
  components: {
    AdminContentItemSendToCompleted,
    AdminContentItemSendToReview,
    AdminContentItemSendToQueue,
    ContentItemDeliverAt,
    AdminContentItemUpdateAttributes,
    TabularHeader,
    AdminContentItemStatus: ContentItemStatusView,
    TextEllipsis
  }
})
export default class AdminContentItemShowTabular extends Vue {
  constructor(private readonly campaignRoute: AdminContentCampaignRoute) {
    super()
  }

  @Prop({ required: true }) contentItem: ContentItemResourceType

  private columns = adminContentItemShowTabularColumns()

  get campaignUrl() {
    return this.contentData.campaign !== null ? this.campaignRoute.show(this.contentData.campaign.id) : '#'
  }

  get contentData() {
    return this.contentItem.data
  }

  get _editorId() {
    return this.contentData?.editor ? this.contentData.editor.id : -1
  }
}
